import { render, staticRenderFns } from "./analysisAgeScatterChart.vue?vue&type=template&id=4f2e4e96&scoped=true"
import script from "./analysisAgeScatterChart.vue?vue&type=script&lang=js"
export * from "./analysisAgeScatterChart.vue?vue&type=script&lang=js"
import style0 from "./analysisAgeScatterChart.vue?vue&type=style&index=0&id=4f2e4e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e4e96",
  null
  
)

export default component.exports